import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container
} from "reactstrap";

import { useNavigate } from 'react-router-dom';

import "./TopicRow.css";

import placeholder from "assets/images/info/card-placeholder-medium.png";

const TopicRow = ({ cards, cardsPerRow, thumbnailUrls, themeName, collectionName }) => {
  const containerRef = useRef(null);
  const navigate = useNavigate();

  return (
    <div
      ref={containerRef}
      className="topic-card"
    >
      {cards.map((card, i) => (
        <div key={i} className="topic-card-outer-div"
          style={{
            width: "80vw",
            height: "70px",
            marginBottom: "22px",
            border: "1px solid silver",
            borderRadius: "10px",
            display: "flex", // ➤ Add this line to enable horizontal layout
            overflow: "hidden"
          }}
          onClick={()=>{
            navigate(`/myInfo/topics/${card._id}`, {
              state: { themeName: themeName, collectionName: collectionName, topicName: card.label }
            })
          }}
        >
          <div className="topic-card-div"
            style={{
              width: "58%", // ➤ Ensure it takes 50% of parent width
              height: "100%",
              backgroundImage: `url(${thumbnailUrls[card._id] || placeholder})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              flexShrink: 0,
              clipPath: "polygon(0 0, 0 100%, 85% 100%, 100% 0)",
              willChange: "background",
              transition: "background 0.8s ease"
            }}
          />
          <div style={{
            width: "50%", // ➤ Text container takes the remaining 50%
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 10px",
          }}>
            <p className="mb-0" style={{ margin: 0, fontSize: "15px" }}>{card.label}</p>
          </div>
        </div>
      ))}
    </div>  
  );
};

export default TopicRow;


